import React from "react";

const Description = () => {
  return (
    <div className="flex justify-center items-center flex-col lg:flex-row w-full h-full">
      <div className="bg2-about lg:w-1/2 w-full"></div>
      <div className=" lg:w-1/2 w-full bg-lightblue-5 lg:h-[700px] lg:px-[60px] px-8">
        <div className="relative flex flex-col gap-6 justify-center w-full h-full max-w-screen-xl text-justify py-10 lg:py-0">
          <p className="text-lg text-blue-5">
            At Clear Choice, we are committed to providing exceptional cleaning
            solutions tailored to meet the unique needs of each client. As a
            premier cleaning services company, we offer a comprehensive range of
            residential, commercial and industrial cleaning services designed to
            enhance the comfort and cleanliness of your space. Our team of
            professional cleaners is highly trained, fully insured, and
            dedicated to delivering meticulous attention to detail with every
            service we provide.
          </p>
          <p className="text-lg text-blue-5">
            Our mission is to exceed your expectations with every clean. We
            understand that a clean environment is crucial for your well-being
            and productivity, and we strive to create spaces that you can be
            proud of. Let us handle the cleaning, so you can focus on what
            matters most to you.
          </p>
          <p className="text-lg text-blue-5">
            Contact us today to schedule your cleaning service and experience
            the Clear Choice difference!
          </p>

          <img
            src="/assets/images/about/arrow.png"
            alt=""
            className="w-full absolute z-0 bottom-10 pointer-events-none"
          />

          <div className="flex w-full justify-end items-center gap-6 mt-5">
            <a
              className="text-md w-[160px] h-[48px] flex items-center justify-center text-white border-2 border-blue-5 bg-blue-5 hover:bg-blue-4 hover:border-blue-4 hover:text-sm transition-all rounded "
              href="tel:+61404509680"
            >
              Call Now
            </a>
            <a
              className="text-md w-[160px] h-[48px] flex items-center justify-center text-blue-5 border-2 border-blue-5 hover:border-blue-4 hover:text-sm transition-all rounded"
              href="/contact"
            >
              Inquire Now
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Description;
